/**
 * @prop --current-lines: Currently clamped lines number (can be used instead of `lines-{BREAKPOINT}` attributes)
 */

stzh-clamp {
  @include host;
  --current-lines: var(--lines, 0);

  @include mq($from: small) {
    --current-lines: var(--lines-small, var(--lines, 0));
  }

  @include mq($from: medium) {
    --current-lines: var(--lines-medium, var(--lines-small, var(--lines, 0)));
  }

  @include mq($from: large) {
    --current-lines: var(--lines-large, var(--lines-medium, var(--lines-small, var(--lines, 0))));
  }

  @include mq($from: ultra) {
    --current-lines: var(--lines-ultra, var(--lines-large, var(--lines-medium, var(--lines-small, var(--lines, 0)))));
  }

  width: 100%;
  color: inherit;
  font-family: inherit;
  font-weight: inherit;
  font-style: inherit;
  font-size: inherit;
  line-height: inherit;
}

.stzh-clamp {
  position: relative;

  &__text {
    @include wordWrap;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;

    & > *:first-child {
      margin-top: 0 !important;
    }

    & > *:last-child {
      margin-bottom: 0 !important;
    }

    &.is-clone {
      position: absolute;
      visibility: hidden;
      opacity: 0;
      top: 0;
      left: 0;
      width: 100%;
    }
  }

  &__trigger {
    @include mq($from: medium) {
      margin-top: space('xxsmall');
    }
  }

  &--is-not-expanded &__text,
  &__text.is-clone {
    -webkit-line-clamp: var(--current-lines);
    line-clamp: var(--current-lines);
  }
}
